import Wrapper from './Wrapper/Wrapper';
import { customTheme } from '../../theme/customTheme';
import { ChakraProvider } from '@chakra-ui/react';
import { BlockchainProvider } from '../../providers/Blockchain/blockchainProvider';
import { MarketProvider } from '../../providers/Market/marketProvider';
import { WalletAccountProvider } from '../../providers/WalletAccount/walletAccountProvider';
import { SearchProvider } from '../../providers/Search/searchProvider';
import '../../lib/i18n/i18n';
import { FeatureProvider } from '../../providers/Feature/featureProvider';
import { PoweredByLabel } from './poweredByLabel';

const App = () => (
	<BlockchainProvider>
		<MarketProvider>
			<WalletAccountProvider>
				<SearchProvider>
					<FeatureProvider>
						<ChakraProvider
							theme={customTheme}
							resetCSS
						>
							<PoweredByLabel />
							<Wrapper />
						</ChakraProvider>
					</FeatureProvider>
				</SearchProvider>
			</WalletAccountProvider>
		</MarketProvider>
	</BlockchainProvider>
);

export default App;
